import { render, staticRenderFns } from "./RiskIndex.vue?vue&type=template&id=1c564ba8&scoped=true&"
import script from "./RiskIndex.vue?vue&type=script&lang=js&"
export * from "./RiskIndex.vue?vue&type=script&lang=js&"
import style0 from "./RiskIndex.vue?vue&type=style&index=0&id=1c564ba8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c564ba8",
  null
  
)

export default component.exports